import { render, staticRenderFns } from "./Clicks.vue?vue&type=template&id=17619972&"
import script from "./Clicks.vue?vue&type=script&lang=js&"
export * from "./Clicks.vue?vue&type=script&lang=js&"
import style0 from "./Clicks.vue?vue&type=style&index=0&id=17619972&prod&lang=scss&"
import style1 from "./Clicks.vue?vue&type=style&index=1&id=17619972&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports